import { FieldWeb } from 'app/shared/model/item.model';

import { FormItemBaseChangeDetector } from './form-item-change-detector-base';

export class PhotoChangeDetector extends FormItemBaseChangeDetector {
  hasChanged(newItem: FieldWeb, oldItem: FieldWeb): boolean {
    return this.hasPhotoChanged(newItem, oldItem);
  }

  private hasPhotoChanged(newItem: FieldWeb, oldItem: FieldWeb): boolean {
    const getPhotoIds = (photos) => photos.map((p) => p.id).join() ?? '';
    const newItemPhotos = getPhotoIds(newItem.photos);
    const oldItemPhotos = getPhotoIds(oldItem.photos);

    return newItemPhotos !== oldItemPhotos;
  }
}
